/**
 * pages.config.js - Page routing configuration
 * 
 * This file is AUTO-GENERATED. Do not add imports or modify PAGES manually.
 * Pages are auto-registered when you create files in the ./pages/ folder.
 * 
 * THE ONLY EDITABLE VALUE: mainPage
 * This controls which page is the landing page (shown when users visit the app).
 * 
 * Example file structure:
 * 
 *   import HomePage from './pages/HomePage';
 *   import Dashboard from './pages/Dashboard';
 *   import Settings from './pages/Settings';
 *   
 *   export const PAGES = {
 *       "HomePage": HomePage,
 *       "Dashboard": Dashboard,
 *       "Settings": Settings,
 *   }
 *   
 *   export const pagesConfig = {
 *       mainPage: "HomePage",
 *       Pages: PAGES,
 *   };
 * 
 * Example with Layout (wraps all pages):
 *
 *   import Home from './pages/Home';
 *   import Settings from './pages/Settings';
 *   import __Layout from './Layout.jsx';
 *
 *   export const PAGES = {
 *       "Home": Home,
 *       "Settings": Settings,
 *   }
 *
 *   export const pagesConfig = {
 *       mainPage: "Home",
 *       Pages: PAGES,
 *       Layout: __Layout,
 *   };
 *
 * To change the main page from HomePage to Dashboard, use find_replace:
 *   Old: mainPage: "HomePage",
 *   New: mainPage: "Dashboard",
 *
 * The mainPage value must match a key in the PAGES object exactly.
 */
import Activities from './pages/Activities';
import Armory from './pages/Armory';
import Artifacts from './pages/Artifacts';
import BriefViewer from './pages/BriefViewer';
import CivilizationMap from './pages/CivilizationMap';
import Codex from './pages/Codex';
import DailyTasks from './pages/DailyTasks';
import Dashboard from './pages/Dashboard';
import Discovery from './pages/Discovery';
import DocumentLibrary from './pages/DocumentLibrary';
import Feedback from './pages/Feedback';
import Framework from './pages/Framework';
import HighCouncil from './pages/HighCouncil';
import Issues from './pages/Issues';
import LighthouseViewer from './pages/LighthouseViewer';
import Missions from './pages/Missions';
import OrgChart from './pages/OrgChart';
import OverallArchitecture from './pages/OverallArchitecture';
import Profile from './pages/Profile';
import TaskBoard from './pages/TaskBoard';
import Welcome from './pages/Welcome';
import __Layout from './Layout.jsx';


export const PAGES = {
    "Activities": Activities,
    "Armory": Armory,
    "Artifacts": Artifacts,
    "BriefViewer": BriefViewer,
    "CivilizationMap": CivilizationMap,
    "Codex": Codex,
    "DailyTasks": DailyTasks,
    "Dashboard": Dashboard,
    "Discovery": Discovery,
    "DocumentLibrary": DocumentLibrary,
    "Feedback": Feedback,
    "Framework": Framework,
    "HighCouncil": HighCouncil,
    "Issues": Issues,
    "LighthouseViewer": LighthouseViewer,
    "Missions": Missions,
    "OrgChart": OrgChart,
    "OverallArchitecture": OverallArchitecture,
    "Profile": Profile,
    "TaskBoard": TaskBoard,
    "Welcome": Welcome,
}

export const pagesConfig = {
    mainPage: "Dashboard",
    Pages: PAGES,
    Layout: __Layout,
};